/** Get the templates for the entity type or types */

import type { Entity, EntityType } from '@tunasong/schemas'
import { usePlugins } from './editor-plugins.js'
import type { Template, TunaPlugin } from '../plugin-types.js'

/** Default template for plugins without templates */
export const getDefaultTemplates = (plugin: TunaPlugin): Template[] =>
  typeof plugin.node?.type === 'string'
    ? [
        {
          name: plugin.key,
          description: plugin.description,
          template: {
            type: plugin.node?.type as EntityType,
          } satisfies Entity,
        },
      ]
    : []

export const useEntityTemplates = (typeOrTypes: EntityType | EntityType[]) => {
  const plugins = usePlugins('all') ?? []
  const entityTypes = Array.isArray(typeOrTypes) ? typeOrTypes : [typeOrTypes]

  const templates = entityTypes
    .flatMap(t =>
      plugins.flatMap(p =>
        p.node?.type === t
          ? (p.templates?.map(t => ({
              ...t,
              icon: t.icon || p.icon,
              description: t.description || p.description,
            })) ?? getDefaultTemplates(p))
          : null
      )
    )
    .filter(Boolean)
  return templates
}
